/** Operational dates use Moscow time, independently of the browser timezone. */
export function moscowDate(date = new Date()) {
  return new Date(date.getTime() + 3 * 60 * 60 * 1000).toISOString().slice(0, 10)
}
